var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button is-primary reset-button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.resetInterview()}}},[_vm._v("\n  Reset Interview\n")])}
var staticRenderFns = []

export { render, staticRenderFns }